import * as React from 'react'
import styled from 'styled-typed'
import Infotip from 'uiComponents/infotip'
import { PageHeaderTooltipContainer } from 'uiComponents/pageElements'
import { Disclamer } from 'dashboard/statsCard'
import { useTranslation } from 'translations'

const TooltipContainer = styled.div`
    position: absolute;
    z-index: 1;
    top: 1.75em;
    left: -1.4em;
`

const ListSection = styled.div`
    margin-top: 1em;
`
const List = styled.ol`
    margin: 0.35em 0 0 0;
    padding-left: 1.1em;
`

interface ReportsPageHeaderInfotipProps {
    pointerOffset: number
    boxOffset: number
    children: React.ReactNode
}

export function ReportsPageHeaderInfotip(props: ReportsPageHeaderInfotipProps) {
    return (
        <PageHeaderTooltipContainer>
            <Infotip pointer="left" maxWidth="69em" pointerOffset={props.pointerOffset} boxOffset={props.boxOffset}>
                {props.children}
            </Infotip>
        </PageHeaderTooltipContainer>
    )
}

interface ChartInfotipProps {
    children: React.ReactNode
    maxWidth: string
    minWidth?: string
}

export function ChartInfotip(props: ChartInfotipProps) {
    return (
        <TooltipContainer>
            <Infotip pointer="left" maxWidth={props.maxWidth} minWidth={props.minWidth}>
                {props.children}
            </Infotip>
        </TooltipContainer>
    )
}

export function TrafficSourseInfotipContent() {
    const { t } = useTranslation()
    return (
        <div>
            {t('reports.trafficSourceInfotip.text')}
            <ListSection>
                {t('reports.trafficSourceInfotip.channelsIntro')}
                <List>
                    <li>{t('reports.trafficSourceInfotip.channels.organicSearch')}</li>
                    <li>{t('reports.trafficSourceInfotip.channels.paidSearch')}</li>
                    <li>{t('reports.trafficSourceInfotip.channels.display')}</li>
                    <li>{t('reports.trafficSourceInfotip.channels.direct')}</li>
                    <li>{t('reports.trafficSourceInfotip.channels.social')}</li>
                    <li>{t('reports.trafficSourceInfotip.channels.email')}</li>
                    <li>{t('reports.trafficSourceInfotip.channels.other')}</li>
                </List>
            </ListSection>
            <Disclamer>{t('reports.reservationsExcluded')}</Disclamer>
        </div>
    )
}

export function TrafficSourseInfotip() {
    return (
        <ChartInfotip maxWidth="40em">
            <TrafficSourseInfotipContent />
        </ChartInfotip>
    )
}
